import { createContext, useContext, type FC, type ReactNode } from 'react'

interface RosterSearchContextValue {
    rosterId: string
    canEdit: boolean
    viewMode: 'on' | 'all'
    onOpenNoteDrawer: (rosterCandidateId: string) => void
}

const RosterSearchContext = createContext<RosterSearchContextValue | null>(null)

interface RosterSearchProviderProps {
    rosterId: string
    canEdit: boolean
    viewMode: 'on' | 'all'
    onOpenNoteDrawer: (rosterCandidateId: string) => void
    children: ReactNode
}

export const RosterSearchProvider: FC<RosterSearchProviderProps> = ({
    rosterId,
    canEdit,
    viewMode,
    onOpenNoteDrawer,
    children,
}) => {
    return (
        <RosterSearchContext.Provider
            value={{ rosterId, canEdit, viewMode, onOpenNoteDrawer }}
        >
            {children}
        </RosterSearchContext.Provider>
    )
}

export const useRosterSearch = () => {
    const context = useContext(RosterSearchContext)
    if (!context) {
        throw new Error(
            'useRosterSearch must be used within RosterSearchProvider'
        )
    }
    return context
}
